import type { CSSProperties } from 'react';
import type { IInstallBannerView } from './InstallBannerView.interface';
import styles from './InstallBannerView.module.css';

export enum StyleElem {
    Container = 'Container',
    Heading = 'Heading',
    SubHeading = 'SubHeading',
    Footer = 'Footer',
}

const DEFAULTS: Record<StyleElem, CSSProperties> = {
    [StyleElem.Container]: {},
    [StyleElem.Heading]: {},
    [StyleElem.SubHeading]: {},
    [StyleElem.Footer]: {},
};

const PROPS_APPLICATOR: Record<StyleElem, (props: IInstallBannerView) => CSSProperties> = {
    [StyleElem.Container]: (props: IInstallBannerView) => ({}),
    [StyleElem.Heading]: (props: IInstallBannerView) => ({
        color: props.heading.color,
        fontWeight: props.heading.fontWeight,
        fontFamily: props.heading.fontFamily,
        fontSize: props.heading.fontSize,
        lineHeight: props.heading.fontSize,
        opacity: props.heading.visible ? 1 : 0,
    }),
    [StyleElem.SubHeading]: (props: IInstallBannerView) => ({
        color: props.subheading.color,
        fontWeight: props.subheading.fontWeight,
        fontFamily: props.subheading.fontFamily,
        fontSize: props.subheading.fontSize,
        lineHeight: props.subheading.fontSize,
        opacity: props.subheading.visible ? 1 : 0,
    }),
    [StyleElem.Footer]: (props: IInstallBannerView) => ({}),
};

export function classNameForElement(element: StyleElem, props: IInstallBannerView): string {
    const name = element.toString();
    const classLoad = styles[name];
    return classLoad || '';
}

export function styleForElement(element: StyleElem, props: IInstallBannerView): CSSProperties {
    const style = { ...DEFAULTS[element], ...PROPS_APPLICATOR[element](props) };

    return style;
}
